import { DotsThreeVertical, Trash } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import { Dialog, DialogContent } from "common/components/ui/Dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";

import DeleteTemplateContent from "./DeleteTemplateContent";

interface TemplateActions {
  templateId: string;
  templateName: string;
}

export default function TemplateActions({
  templateId,
  templateName,
}: TemplateActions) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger data-cy="template-actions-dropdown" asChild>
          <Button intent="iconOnly" variant="secondary-black">
            <DotsThreeVertical />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuList>
            <DropdownMenuItem
              variant="danger"
              data-cy="delete-template-menu-item"
              onClick={() => setIsOpen(true)}
            >
              <Trash />
              Delete template
            </DropdownMenuItem>
          </DropdownMenuList>
        </DropdownMenuContent>
      </DropdownMenu>

      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent>
          <DeleteTemplateContent
            templateId={templateId}
            templateName={templateName}
            onCancel={() => setIsOpen(false)}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
